import React from 'react';
import classnames from 'classnames';
import s from './BulletItem.scss';

interface Props {
  children: React.ReactNode;
  bullet?: React.ReactNode;
  className?: string;
  textClassName?: string;
}

const BulletItem: React.FC<Props> = ({
  bullet,
  children,
  className,
  textClassName,
}) => (
  <li className={classnames(s['item'], className)}>
    {bullet && (
      <span className={s['bullet']} aria-hidden={true}>
        {bullet}
      </span>
    )}
    <span className={classnames(s['text'], textClassName)}>{children}</span>
  </li>
);
BulletItem.displayName = 'IconBullet';
export default BulletItem;
